'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var TOGGLE_CHAT = exports.TOGGLE_CHAT = 'TOGGLE_CHAT';
var TOGGLE_INPUT_DISABLED = exports.TOGGLE_INPUT_DISABLED = 'TOGGLE_INPUT_DISABLED';
var ADD_NEW_USER_MESSAGE = exports.ADD_NEW_USER_MESSAGE = 'ADD_NEW_USER_MESSAGE';
var ADD_NEW_RESPONSE_MESSAGE = exports.ADD_NEW_RESPONSE_MESSAGE = 'ADD_NEW_RESPONSE_MESSAGE';
var ADD_NEW_RESPONSE_CHOICES = exports.ADD_NEW_RESPONSE_CHOICES = 'ADD_NEW_RESPONSE_CHOICES';
var ADD_NEW_LINK_SNIPPET = exports.ADD_NEW_LINK_SNIPPET = 'ADD_NEW_LINK_SNIPPET';
var ADD_COMPONENT_MESSAGE = exports.ADD_COMPONENT_MESSAGE = 'ADD_COMPONENT_MESSAGE';
var DROP_MESSAGES = exports.DROP_MESSAGES = 'DROP_MESSAGES';
var SET_FULLSCREEN = exports.SET_FULLSCREEN = 'SET_FULLSCREEN';
var UNSET_FULLSCREEN = exports.UNSET_FULLSCREEN = 'UNSET_FULLSCREEN';